<template>
		<div class="listingSidebar sidebar algoliaSidebar">
			<div class="sidebarInner">
				<ais-clear-refinements>
					<span slot="resetLabel">Clear Filters</span>
				</ais-clear-refinements>

				<ais-hierarchical-menu
					:attributes="[
					'categories.lvl0',
					'categories.lvl1',
					'categories.lvl2'
					]"

					:class-names="{
						'ais-HierarchicalMenu': 'sidebarInner',
						'ais-HierarchicalMenu-item': 'sidebarItem',
						'ais-HierarchicalMenu-link' : 'triangle',
						// 'ais-HierarchicalMenu-link' : 'ais-HierarchicalMenu-link triangle'

					}" 
				/>
				<div class="brands-container padding-top greenBox">
					Can’t see what you want. Go to the brand supplier’s website through <router-link class="inline" :to="{name:'brands'}">brands listing</router-link>, find what you want, click ‘<router-link class="inline" :to="{name: 'brands'}">Get a Price</router-link>’ and get our everyday heavily discounted price.
				</div>
			</div>
		</div>
</template>


<script>
import { AisHierarchicalMenu } from 'vue-instantsearch';
import { AisClearRefinements } from "vue-instantsearch";


export default {
	name: "AlgoliaSidebar",
	components:{
		AisHierarchicalMenu,
		AisClearRefinements
	}
}

</script>


<style lang="scss" scoped>
.result {
	padding-top: 20px;
	strong {
		font-weight: normal;
		background: red;
	}
}

.inline{
	display: inline !important;
	padding: 0 !important;
	text-decoration: underline !important;
}

.brands-container{
	border-top: 1px #888 solid;
	box-sizing: border-box;
	padding: 5px;
}

</style>
